import React, { useEffect, useState } from "react";
import { FlexGrid } from '@grapecity/wijmo.react.grid';
import AutoDataGridColumn from '../grid/functional/AutoDataGridColumn';
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import apiClient from "../../lib/common/apiClient";
import getSpecific from "../../lib/api/getSpecific";


/**
 * @COMPONENT_NAME MachineDataCollectorManagement
 * @DESCRIPTION 설비 데이터 수집 모듈 관리 화면 컴포넌트 
 *              
 * @PASSTHROUGH_PROPS
 * @CALLBACKS
 */
function MachineDataCollectorManagement(props) {
    const [isLoading, setIsLoading] = useState(true);
    

    useEffect(() => {
         ( async () => {
            
            setIsLoading(true);
            
            
            // 모듈 목록 맞추기가 실패해도(모듈 폴더 · 표 없음) 목록을 띄워 목록 조회의 실패 알림을 보인다 — 안 그러면 빈 화면에 멈춘다
            await apiClient.get(`/api/MachineDataCollectorManagement/`).catch(() => {});
            
            setIsLoading(false);
         })();
    }, []);

    
    return (
        <>
            
            {!isLoading && (
                
                <BasicCrudScreenType
                    id="VwMachineDataCollectorManagement"
                    table="MachineDataCollectorManagement"
                    view="VwMachineDataCollectorManagement"
                    noCreate
                    noDelete
                    // schema={schema}
                    // onLoadData={data} // 데이터 직접 주입
                    noExcel
                />
            )}
        </>
    );
}

export default MachineDataCollectorManagement;
